module.exports = __webpack_public_path__ + "img/map.9281a6d5.png";